import { render, staticRenderFns } from "./ProgramImages.vue?vue&type=template&id=0a36a17a&scoped=true"
import script from "./ProgramImages.vue?vue&type=script&lang=js"
export * from "./ProgramImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a36a17a",
  null
  
)

export default component.exports